import { render, staticRenderFns } from "./blindAward.vue?vue&type=template&id=a4ed5784&scoped=true&"
import script from "./blindAward.vue?vue&type=script&lang=js&"
export * from "./blindAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ed5784",
  null
  
)

export default component.exports